import toast from 'react-hot-toast';
import config from '../../../../config';
import { getAuthToken } from '../../../utils/auth';

const putSwitchMonetizeType = async (publisherId, category, monetizeType) => {
  const accessToken = getAuthToken();

  const payload = {
    category,
    monetizeType,
    publisherId,
  };

  const response = await fetch(
    `${config.ApiBaseUrl}/wordpress/switchCategoryMonetizeType`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const useToggleMonetize = (categoriesMap, selectedCategories, publisherId) => {
  const handleToggle = (monetizeType) => {
    const arr = [];

    selectedCategories.forEach((value, key) => {
      if (value) {
        const category = categoriesMap.get(key);
        arr.push(putSwitchMonetizeType(publisherId, category, monetizeType));
      }
    });
    // for (const [key, value] of selectedCategories) {
    //   if (value) {
    //     const category = categoriesMap.get(key);
    //     arr.push(putSwitchMonetizeType(publisherId, category, monetizeType));
    //   }
    // }

    Promise.all(arr)
      .then(() => {
        toast.success(`Selected Categories switched to ${monetizeType}`);
      })
      .catch((e) => {
        toast.error('something went wrong!');
      });
  };

  return handleToggle;
};

export default useToggleMonetize;
